import { useContext, useEffect } from 'react';
import { UserContext } from './useUser';
import { useNavigate } from 'react-router-dom';
import { Role } from '../../enums/Role';
import Layout from './layout/Layout';
import ErrorPage from '../../pages/ErrorPage';

const NoPermissionPage = () => {
  return (<Layout>
    <ErrorPage variant='403' />
  </Layout>);
};

interface AuthGuardProps {
  children: JSX.Element;
  optionalChildren?: JSX.Element;
  permissions: Role[];
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, optionalChildren, permissions }) => {
  const navigate = useNavigate();
  const { hasPermissionTo, hasPermissions, selectedStore } = useContext(UserContext);

  useEffect(() => {
    if (!hasPermissions() || !selectedStore) {
      navigate('/login');
    }
  }, []);

  if (!hasPermissions()) {
    return null;
  }

  if (permissions && permissions.length > 0 && !hasPermissionTo(permissions)) {
    return <NoPermissionPage />;
  }

  return children;
};

export default AuthGuard;
